module.exports = __webpack_public_path__ + "User Icon.jpg?f81e60ed4b127a677bab69e294fd1d15";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/User Icon.jpg
// module id = 443
// module chunks = 0